import { render, staticRenderFns } from "./ParentMoney.vue?vue&type=template&id=74c15592"
import script from "./ParentMoney.vue?vue&type=script&lang=js"
export * from "./ParentMoney.vue?vue&type=script&lang=js"
import style0 from "./ParentMoney.vue?vue&type=style&index=0&id=74c15592&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports